/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import { Col, Row } from "antd";
import React from "react";
import {
  getMenuParentElements,
  getParentMenuChildren,
} from "../../menuHelpers";

// MuotolevyDesktopMenu menu
export const MuotolevyDesktopMenu = (props) => {
  const { sitemegamenumuotolevy } = props;
  // NOTE: use sitemegamenumuotolevy instead of sitemegamenu
  const [muotolevyParentMenu] = getMenuParentElements(sitemegamenumuotolevy);
  const { menuChildren } = getParentMenuChildren(
    sitemegamenumuotolevy,
    muotolevyParentMenu.ID,
  );
  if (menuChildren.length === 0) return null;
  return (
    <div className="megamenu__wrapper contact-menu">
      <div className="megamenu__container contact-menu">
        <Row gutter={64}>
          <Col span={24}>
            <Row gutter={32} style={{ width: "100%" }}>
              <Col span={24}>
                <ul>
                  {menuChildren.map((item) => (
                    <li className={`${item.classes[0]} no-border`}>
                      <a href={item.url}>{item.title}</a>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default MuotolevyDesktopMenu;
